 /* FETCH PRODUCTS - ADDED */
async function fetchCollectionProducts(handle) {
  try {
    const response = await fetch(`/collections/${handle}/products.json`);
    if (!response.ok) throw new Error("Problème lors de la récupération des produits");

    const data = await response.json();
    //console.log("Produits récupérés :", data.products);

    // Vérification des produits en wishlist après récupération
    checkWishlistStatus(data.products);

    return data.products;
  } catch (error) {
    //console.error("Erreur :", error);
  }
}

const collectionHandle = window.location.pathname.split("/").pop();
fetchCollectionProducts(collectionHandle);

async function checkWishlistStatus() {
  //console.log("🔍 Vérification de la wishlist pour USER_ID:", USER_ID);

  // Récupérer tous les produits affichés sur la page
  //const products = document.querySelectorAll(".main-products-grid .wishlist-heart");
  const products = document.querySelectorAll(".main-products-grid .wishlist-heart");

  // Construire la liste des produits à vérifier
  const productList = Array.from(products).map(heart => ({
    product_id: heart.getAttribute("data-product-id"),
    variant_id: heart.getAttribute("data-variant-id") || null,
    variant_sku: heart.getAttribute("data-variant-sku") || null
  })).filter(item => item.product_id); // Exclure les éléments sans product_id

  // Vérification
  if (productList.length === 0) {
    //console.warn("⚠️ Aucun produit trouvé sur la page.");
    return;
  }

  //console.log("📦 Produits à vérifier :", productList);

  // Envoyer tous les produits à l'API
  fetch(API_URL, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': '2ea53aad035ab2da4e71ab366948f30a',
    },
    body: JSON.stringify({
      action: 'check_products',
      store: "prod",
      user_id: USER_ID,
      products: productList // 🔥 On envoie TOUS les produits ensemble
    }),
  })
  .then(async response => {
    //console.log("🔄 Statut de la réponse HTTP :", response.status);

    if (!response.ok) {
      // console.error("🚨 Erreur HTTP :", response.status, response.statusText);
      return;
    }

    const text = await response.text();

    // console.log("📄 Réponse brute de l'API :", text);

    if (!text) {
      //console.error("⚠️ Réponse vide de l'API !");
      return;
    }

    try {
      const result = JSON.parse(text);
      //console.log("✅ Résultat de l'API ==:", result);

      if (result.exists) {        
        //console.log("🟢 DOM chargé, mise à jour des produits...");

        document.querySelectorAll(".main-products-grid .wishlist-heart").forEach(heart => {            
          const productId = heart.getAttribute("data-product-id");

          if (result.items.some(item => item.product_id == productId)) { 
            heart.classList.add('wishlist-heart--added');
            //console.log(`❤️ Produit en wishlist : ${productId}`);
          } else {
            //console.log(`❌ Produit NON en wishlist : ${productId}`);
          }
        });

        //console.log("✅ Wishlist mise à jour avec les produits existants.");
      } else {
        //console.error("🔴 Produit non trouvé en wishlist :", result);
      }
    } catch (error) {
      //console.error("🚨 Problème lors du parsing JSON :", error);
      //console.log("📄 Réponse brute (erreur JSON) :", text);
    }
  })
  .catch(error => console.error("🚨 Erreur JS lors du fetch :", error));
}

const API_URL = '/apps/larecharge/wishlist';
const USER_ID = document.body.getAttribute('data-customer-id') || null;
const USER_EMAIL = document.body.getAttribute('data-customer-email') || null;
const wishlists = JSON.parse(localStorage.getItem('wishlists')) || {};
const modal = document.getElementById('add-to-wishlist-modal');
const modalMessage = document.getElementById('modal-message');
const wishlistList = document.getElementById('wishlist-list');
const wishlistNameInput = document.getElementById('wishlist-name');
const createWishlistBtn = document.getElementById('create-wishlist-btn');
const saveToWishlistBtn = document.getElementById('save-to-wishlist-btn');
const closeModalBtn = document.querySelector('.close-btn');
//console.log(USER_EMAIL);
let selectedProduct = null;

// Ouvrir la modal pour ajouter un produit à une liste de souhaits
document.querySelectorAll('.wishlist-heart').forEach(heart => {
  heart.addEventListener('click', async () => {
    selectedProduct = {
      id: heart.dataset.productId,
      title: heart.dataset.productTitle,
      variantId: heart.dataset.variantId
    };

    if (!selectedProduct.id || !selectedProduct.variantId) {
      // console.error("⚠️ Produit ou variante manquants !");
      return;
    }

    const isAdded = heart.classList.contains('wishlist-heart--added');

    if (isAdded) {
      // 🔴 Si le produit est déjà ajouté → on le supprime directement sans ouvrir la modal
      removeFromWishlist(heart, selectedProduct);
    } else {
      // 🟢 Si le produit n'est pas dans la wishlist → Ouvrir la modal
      renderWishlistOptions();
      modal.classList.add('active');
    }
  });
});

// Fermer la modal
closeModalBtn.addEventListener('click', () => {
  modal.classList.remove('active');
});

const fetchRealWishlist = async () => {
  //console.log("🔄 Appel API pour récupérer les wishlists de la BD...");

  try {
    const response = await fetch(`${API_URL}?user_id=${USER_ID}&nocache=${Date.now()}`, {
      headers: {
        "Authorization": "2ea53aad035ab2da4e71ab366948f30a" // Clé API
      }
    });

    //console.log("✅ Statut HTTP :", response.status);
    const text = await response.text(); // Lire la réponse brute
    //console.log("🔍 Réponse brute de l'API :", text);

    // Vérifier si la réponse est bien du JSON
    let data;
    try {
      data = JSON.parse(text);
    } catch (error) {
      // console.error("❌ Erreur de parsing JSON :", error);
      return [];
    }

    //console.log("📦 Données JSON reçues :", data);

    if (data.lists && Array.isArray(data.lists)) {
      //console.log("✅ Wishlists récupérées :", data.lists);
      return data.lists;
    } else {
      // console.warn("⚠️ Aucune liste trouvée, structure incorrecte ?");
      return [];
    }
  } catch (error) {
    // console.error("❌ Erreur lors de la récupération des données :", error);
    return [];
  }
};

// Utilisation pour mettre à jour l'affichage avec les données réelles
const renderWishlistOptions = async () => {
  //console.log("🚀 renderWishlistOptions() appelé !");
  wishlistList.innerHTML = '';

  const wishlists = await fetchRealWishlist(); // Récupération des produits depuis la BD
  //console.log("📦 Wishlists reçues :", wishlists);
  //console.log("Nombre d'éléments dans wishlists :", wishlists.length);
  // ✅ Parcourir le tableau correctement
  wishlists.forEach(wishlist => {
    const box = document.createElement('div');
    box.className = 'checkbox-box';
    box.textContent = wishlist.name; // ✅ Afficher le nom et non l'ID

    box.addEventListener('click', () => {
      box.classList.toggle('selected');
    });
    wishlistList.appendChild(box);
  });
};

// Appeler la fonction pour afficher les données réelles
renderWishlistOptions();

const addWishlistToDB = async (userId, userEmail, wishlistName) => {

  try {
    const response = await fetch(`${API_URL}`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Authorization": "2ea53aad035ab2da4e71ab366948f30a"
      },
      body: JSON.stringify({
        action: "add_list",
        store: "prod",
        shopify_user_id: userId, // Utilisation du Shopify ID
        email: userEmail,
        lists: [{ name: wishlistName, products: [] }]
      })
    });

    const data = await response.json();
    //console.log("Réponse API :", data); // Ajout d'un log pour voir l'erreur

    return response.ok; // Retourne true si la requête a réussi
  } catch (error) {
    // console.error("Erreur de connexion à l'API :", error);
    return false;
  }
};

const checkIfListExists = async (userId, userEmail, wishlistName) => {
  //console.log(wishlistName);
  try {
    const response = await fetch(`${API_URL}`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Authorization": "2ea53aad035ab2da4e71ab366948f30a"
      },
      body: JSON.stringify({
        action: "check_list",
        store: "prod",
        user_id: userId,
        email: userEmail,
        list_name: wishlistName
      })
    });

    const data = await response.json();

    if (!response.ok) {
      // console.error("Erreur API :", data);
      throw new Error(data.error || "Erreur inconnue lors de la requête API");
    }

    //console.log("Réponse API :", data); // Vérifier la réponse dans la console

    return data.exists || false; // Retourne true si la liste existe, sinon false

  } catch (error) {
    // console.error("Erreur de connexion à l'API :", error);
    return false;
  }
};

const checkIfProductExistsInList = async (userId, listId, productId, variantId, variantSku) => {
  try {
    const response = await fetch(`${apiUrl}`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Authorization": apiKey
      },
      body: JSON.stringify({
        action: "check_product",
        store: "prod",
        user_id: userId,
        list_id: listId,
        product_id: productId,
        variant_id: variantId,
        variant_sku: variantSku
      })
    });

    const data = await response.json();

    if (!response.ok) {
      // console.error("Erreur API :", data);
      return false;
    }

    return data.exists; // Retourne true si le produit est dans la liste, sinon false

  } catch (error) {
    // console.error("Erreur de connexion à l'API :", error);
    return false;
  }
};


createWishlistBtn.addEventListener("click", async () => {
  const name = wishlistNameInput.value.trim();

  if (!name) {
    showModalMessage("Veuillez entrer un nom.", "error");
    return;
  }
  const isListExists = await checkIfListExists(USER_ID, USER_EMAIL, name);
  //console.log(isListExists);
  if (isListExists) {
    showModalMessage("Cette liste existe déjà.", "error");
    return;
  }

  // ✅ Envoyer la wishlist à la BD
  const success = await addWishlistToDB(USER_ID, USER_EMAIL, name);
  if (success) {
    //wishlists[name] = [];
    //localStorage.setItem("wishlists", JSON.stringify(wishlists));
    //wishlistNameInput.value = "";
    renderWishlistOptions();
    showModalMessage("Liste de souhaits créée avec succès !", "success");
  } else {
    showModalMessage("Échec de la création de la liste.", "error");
  }
});


// Sauvegarder un produit dans des listes
saveToWishlistBtn.addEventListener('click', async () => {
  const selectedBoxes = document.querySelectorAll('.checkbox-box.selected');
  const wishlistNameInputValue = wishlistNameInput.value.trim();
  let newLists = [];

  if (!selectedBoxes.length && !wishlistNameInputValue) {
    showModalMessage('Veuillez sélectionner ou créer une liste.', 'error');
    return;
  }

  // Créer une nouvelle liste si un nom est saisi
  if (wishlistNameInputValue && !wishlists[wishlistNameInputValue]) {
    wishlists[wishlistNameInputValue] = [];
    newLists.push({
      name: wishlistNameInputValue,
      products: [{ id: selectedProduct.id, variant_id: selectedProduct.variantId }],
    });
  }

  // ✅ Utiliser `for...of` pour éviter l'erreur `await` dans `forEach`
  for (const box of selectedBoxes) {
    const listName = box.textContent.trim();

    // 🔍 Vérifier si la liste existe avec `await`
    const isListExists = await checkIfListExists(USER_ID, USER_EMAIL, listName);
  
    // Vérifier si la liste existe, sinon l'initialiser
    if (!isListExists) {
      //console.warn(`⚠️ La liste "${listName}" n'existe pas ou n'est pas un tableau. Initialisation...`);
    }

    const isProductInList = await checkIfProductExistsInList(USER_ID, listName, selectedProduct.id, selectedProduct.variantId);
    // Vérifier si le produit est déjà dans la liste avant de l'ajouter
    if (!isProductInList) {      
      //wishlists[listName].push(selectedProduct);
    }
  
    newLists.push({
      name: listName,
      products: [{ id: selectedProduct.id, variant_id: selectedProduct.variantId }],
    });
  }

  // Sauvegarder dans localStorage
  //localStorage.setItem('wishlists', JSON.stringify(wishlists));

  // Marquer le produit comme ajouté
  document.querySelector(`[data-product-id="${selectedProduct.id}"]`).classList.add('wishlist-heart--added');

  // Envoyer les données à l'API
  sendWishlistsToAPI(USER_ID, USER_EMAIL, newLists);

  modal.classList.remove('active');
  showModalMessage('Produit ajouté à la liste avec succès !', 'success');
});


// ✅ Ajouter un produit à une liste existante sans recréer la liste
async function addProductToWishlist(product, heart) {

  try {
    // Vérifier si l'utilisateur a des listes existantes
    const response = await fetch(`${API_URL}?user_id=${USER_ID}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': '2ea53aad035ab2da4e71ab366948f30a',
      },
    });

    const data = await response.json();
    const existingLists = data.lists || [];

    if (existingLists.length === 0) {
      //console.warn("⚠️ Aucun wishlist trouvée. Créez d'abord une wishlist.");
      return;
    }

    // Prendre la première liste existante pour y ajouter le produit
    const targetList = existingLists[0]; // On suppose que l'utilisateur a une seule liste

    const addProductResponse = await fetch(API_URL, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': '2ea53aad035ab2da4e71ab366948f30a',
      },
      body: JSON.stringify({
        action: 'add_product',
        store: "prod",
        user_id: USER_ID,
        list_id: targetList.id, // Utilise la liste existante
        product_id: product.id,
        variant_id: product.variantId
      }),
    });

    const addProductResult = await addProductResponse.json();

    if (addProductResult.success) {
      heart.classList.add('wishlist-heart--added');
      //console.log(`✅ Produit ajouté à la wishlist : ${targetList.name}`);
    } else {
      // console.error("🚨 Erreur API :", addProductResult);
    }
  } catch (error) {
    // console.error("🚨 Erreur lors de l'ajout du produit à la wishlist :", error);
  }
}

// ✅ Gérer l'ajout et la suppression des produits de la wishlist
document.querySelectorAll('.wishlist-heart').forEach(heart => {
  heart.addEventListener('click', async () => {
    const selectedProduct = {
      id: heart.dataset.productId,
      variantId: heart.dataset.variantId
    };

    if (!selectedProduct.id || !selectedProduct.variantId) {
      //console.error("⚠️ Produit ou variante manquants !");
      return;
    }

    const isAdded = heart.classList.contains('wishlist-heart--added');

    if (isAdded) {
      removeFromWishlist(heart, selectedProduct);
    } else {
      addProductToWishlist(selectedProduct, heart);
    }
  });
});

// 🔴 Supprimer un produit spécifique de la wishlist
async function removeFromWishlist(heart, product) {
  //console.log("sdfsf", USER_ID, heart, product);
  //return;
  try {
    const response = await fetch(API_URL, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': '2ea53aad035ab2da4e71ab366948f30a',
      },
      body: JSON.stringify({
        action: 'delete_product_wishlist',
        store: "prod",
        user_id: USER_ID,
        product_id: product.id,
        variant_id: product.variantId
      }),
    });

    const result = await response.json();

    if (result.success) {
      heart.classList.remove('wishlist-heart--added');
      //console.log(`❌ Produit ${product.id} retiré de la wishlist`);
    } else {
      // console.error("🔴 Erreur API :", result.error);
    }
  } catch (error) {
    // console.error("🚨 Erreur lors de la requête API :", error);
  }
}

// Fonction pour afficher un message dans la modal
const showModalMessage = (message, type) => {
  modalMessage.textContent = message;
  modalMessage.className = `message message--${type}`;
  modalMessage.style.display = 'block';
  setTimeout(() => {
    modalMessage.style.display = 'none';
  }, 3000);
};

// Fonction pour envoyer les listes et produits à l'API
const sendWishlistsToAPI = (shopify_user_id, user_email, newLists) => {
  //console.log("ICI ICI", shopify_user_id, user_email, newLists);
  const data = {
    action: 'add_list',
    store: "prod",
    shopify_user_id: shopify_user_id,
    email: user_email,
    lists: newLists,
  };

  fetch(API_URL, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': '2ea53aad035ab2da4e71ab366948f30a',
    },
    body: JSON.stringify(data),
  })
    .then(response => response.json())
    .then(result => {
      if (result.success) {
        //console.log('Data successfully sent to the API:', result);
      } else {
        // console.error('Error from API:', result);
      }
    })
    .catch(error => console.error('Error sending data to API:', error));
};
